import Utils from './Utils';

class SoundManager
{
    init(game, params)
    {
        if (!this._initialized)
        {
            this.game = game;
            this.soundManager = new Phaser.SoundManager(game);
            this.musicManager = new Phaser.SoundManager(game);
        }

        this.sound = !!params.sound;
        this._soundVolume = params.soundVolume || 1;

        this.music = !!params.music;
        this._musicVolume = params.musicVolume || 1;

        this.enabled = true;

        this._initialized = true;
    }

    get enabled()
    {
        return !!this._enabled;
    }

    set enabled(value)
    {
        this._enabled = value;
        this.music = this.music;
    }

    get sound()
    {
        return this._sound;
    }

    set sound(value)
    {
        this._sound = !!value;

        if (value && this.enabled)
        {
            this.soundManager.resumeAll();
        }
        else
        {
            this.soundManager.stopAll();
        }
    }

    get music()
    {
        return this._music;
    }

    set music(value)
    {
        this._music = !!value;

        if (value && this.enabled)
        {
            this.musicManager.resumeAll();
        }
        else
        {
            this.musicManager.pauseAll();
        }
    }

    playSound(key, loop = false, fadeMusic = false)
    {
        let sound = this.soundManager.play(key, this._soundVolume, loop);
        if (!this.enabled || !this.sound)
        {
            sound.stop();
        }
        else if (fadeMusic)
        {
            this.fadeOutMusic(100, 0.05);
            sound.onStop.addOnce(() =>
            {
                if (this._musicSound.fadeTween && !this._musicSound.fadeTween.isRunning)
                {
                    this.fadeInMusic();
                }
            });
        }
        return sound;
    }

    playMusic(key, volume = this._musicVolume)
    {
        if (this._musicSound)
        {
            this.remove(this._musicSound);
            this._musicSound.stop();
        }

        const sound = this.musicManager.play(key, volume, true);
        this._musicSound = sound;

        if (!this.music)
        {
            sound.pause();
        }

        return sound;
    }

    fadeOutMusic(duration = 100, value = 0.05)
    {
        if (!this._musicSound)
        {
            return Promise.resolve();
        }

        this._musicSound.fadeTo(duration, value);
        return Utils.makeTimeoutPromise(duration);
    }

    fadeInMusic(duration = 100)
    {
        if (!this._musicSound)
        {
            return Promise.resolve();
        }

        this._musicSound.fadeTo(duration, this._musicVolume);
        return Utils.makeTimeoutPromise(duration);
    }

    stopMusic()
    {
        if (this._musicSound)
        {
            this._musicSound.stop();
        }
    }

    restartMusic()
    {
        if (this._musicSound)
        {
            this._musicSound.restart();
        }
    }

    remove(sound)
    {
        return this.musicManager.remove(sound) || this.soundManager.remove(sound);
    }

    removeByKey(key)
    {
        return this.musicManager.removeByKey(key) || this.soundManager.removeByKey(key);
    }
}

export default new SoundManager();